import { Injectable, inject, signal, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export type LlmStatus = 'online' | 'offline' | 'unknown';

export interface LlmHealth {
  online: boolean;
  model: string;
  model_available: boolean;
  latency_ms: number | null;
  error?: string;
}

const POLL_INTERVAL_MS = 4 * 60 * 60 * 1000;  // 4 hours

@Injectable({ providedIn: 'root' })
export class LlmStatusService implements OnDestroy {
  private http = inject(HttpClient);

  readonly status    = signal<LlmStatus>('unknown');
  readonly health    = signal<LlmHealth | null>(null);
  readonly checking  = signal(false);
  readonly lastCheck = signal<Date | null>(null);

  private timer: ReturnType<typeof setInterval> | null = null;

  constructor() {
    this.check();
    this.timer = setInterval(() => this.check(), POLL_INTERVAL_MS);
  }

  check(): void {
    this.checking.set(true);
    this.http.get<LlmHealth>(`${environment.apiUrl}/llm/health`).subscribe({
      next: data => {
        this.health.set(data);
        this.status.set(data.online && data.model_available ? 'online' : 'offline');
        this.lastCheck.set(new Date());
        this.checking.set(false);
      },
      error: () => {
        this.health.set(null);
        this.status.set('offline');
        this.lastCheck.set(new Date());
        this.checking.set(false);
      },
    });
  }

  ngOnDestroy(): void {
    if (this.timer !== null) clearInterval(this.timer);
  }
}
